import { UserConstants } from '../constants';

let initialState = { certificateDetails: [], detailsLoading: false, detailsExists: false, detailsError: '' };
export function certificateDetails(state = initialState, action) {
    switch (action.type) {
    case UserConstants.UCDETAILS_SUCCESS:
        return {
            certificateDetails: action.payload.data,
            detailsExists: true,
            detailsLoading: false,
            detailsError: '',
        };
    case UserConstants.UCDETAILS_REQUEST:
        return {
            certificateDetails: [],
            detailsLoading: true,
            detailsExists: false,
            detailsError: '',
        };
    case UserConstants.UCDETAILS_ERROR:
        return {
            certificateDetails: [],
            detailsExists: false,
            detailsLoading: false,
            detailsError: action.payload.message
        };
    default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/CertificateDetails.jsx